import config from "../config";

const baseUrl = config.base_url + "c_life/ys7/";

export default {
    listCameras: {
        url: baseUrl + "camera/list",
        type: "get",
    },
    listCaptures: {
        url: baseUrl + "camera/captures",
        type: "get",
    },
    listPresets: {
        url: baseUrl + "camera/presets",
        type: "get",
    },
    addPreset: {
        url: baseUrl + "camera/preset/add",
        type: "post",
    },
    movePreset: {
        url: baseUrl + "camera/preset/move",
        type: "post",
    },
    clearPreset: {
        url: baseUrl + "camera/preset/clear",
        type: "post",
    },
    updatePreset: {
        url: baseUrl + "camera/preset/update",
        type: "post",
    },
    getSchedule: {
        url: baseUrl + "camera/capture/schedule",
        type: "get",
    },
    capture: {
        url: baseUrl + "camera/capture",
        type: "post",
    },
};
